import React, { Component } from 'react';
import { Link, NavLink, withRouter } from 'react-router-dom';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { clientAccessHelpers } from '../../../../hooks/useClientAccess';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import TimelineIcon from '@material-ui/icons/Timeline';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import Popover from '@material-ui/core/Popover';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import FilterListIcon from '@material-ui/icons/FilterList';
import BarChartOutlinedIcon from '@material-ui/icons/BarChartOutlined';
import UpdateIcon from '@material-ui/icons/Update';
import {getObjectivesIgnoreCache} from '../../../../services/getObjectives';
import { reportFetchError } from '../../../../observability/rum';
import Icon from '@material-ui/core/Icon';
import CircularProgress from '@material-ui/core/CircularProgress';
import Collapse from '@material-ui/core/Collapse';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import QuickreplyIcon from '@mui/icons-material/Quickreply';
import TrafficIcon from '@mui/icons-material/Traffic';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import PublicIcon from '@material-ui/icons/Public';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import HomeIcon from '@material-ui/icons/Home';
import QuizIcon from '@mui/icons-material/Quiz';
import MenuIcon from '@material-ui/icons/Menu';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import PerfectScrollbar from 'react-perfect-scrollbar';
import SpeedIcon from '@mui/icons-material/Speed';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import InsightsIcon from '@mui/icons-material/Insights';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SyncIcon from '@mui/icons-material/Sync';
import SummaryObjectives from '../../../../views/Dashboard/components/SummaryObjectives';


// Component styles
import styles from './styles';
import { api_host } from '../../../../common/globals/constants';
import { Grid } from '@material-ui/core';
import moment from 'moment'
import 'moment/locale/es'
import { getSidebarOptions, saveSidebarOptions, sidebarFiltersTags } from '../../../../utils/local-storage/sidebar-options';
import { FilterTags } from '../../../../components/TagsAtentus/FilterTags';
import ChipTag from '../../../../components/TagsAtentus/ChipTag';
import { ChipVerMas } from '../../../../views/ManageObjective/components/ListObjectives';
import { getQueryParams } from '../../../../utils/fns/get-query-params';
import { withTranslation } from 'react-i18next';
moment.locale('es')

const objectiveConfigProfileAccess = [1, 2, 5]

class Sidebar extends Component {
    constructor(props) {
        super(props);
        
        const activeObjetivoId = props.match?.params?.objetivo_id;

        const savedCollapsedStatus = getSidebarOptions()
        const filterTags = sidebarFiltersTags.getSidebarFilterTags()
        const filterType = sidebarFiltersTags.getFilterType();
        const clienteId = sessionStorage.getItem('client_id')
        this.state = {
            listaObjetivos: {},
            listaObjetivosOnline: {},
            listaServicios: {},
            cargando: true,
            anchorEl: null,
            checked: [],
            checkedBase: 0,
            isBallotIconChecked: false,
            setChecked: [],
            token:sessionStorage.getItem('key'),
            user:sessionStorage.getItem("user"),
            openModal: false,
            dateMoment:(moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"),
            profileId: sessionStorage.getItem('profile_id'),
            special:false,
            listObjectivesSpecials:[],
            nameSide:"Monitoreos",
            openCollapse: !props.collapsed && savedCollapsedStatus.openCollapse,
            openCollapseMonitor: !props.collapsed && savedCollapsedStatus.openCollapseMonitor,
            openCollapseBoard: !props.collapsed && savedCollapsedStatus.openCollapseBoard,
            openCollapseDashboards: !props.collapsed && savedCollapsedStatus.openCollapseDashboards,
            anchorElSupport: null,
            anchorElMonitor: null,
            anchorElBoard: null,
            anchorElEtiquetas: null,
            filterTags: filterTags || [],
            filteredListObjectives: [],
            activeObjetivoId,
            filterTagsType: filterType,
            clienteId,
            isAdmin: Boolean(sessionStorage.getItem('admin_id')) || false
        }        
    }

    

    componentDidUpdate(prevProps, prevState) {
        if(prevState.dateMoment!== this.state.dateMoment || prevState.special!==this.state.special){
            this.loadObjectives()
        }

        if(!prevProps.collapsed && (prevProps.collapsed !== this.props.collapsed)) {
            this.setState({
                openCollapse: false,
                openCollapseMonitor: false,
                openCollapseBoard: false,
                anchorElSupport: null,
                anchorElMonitor: null,
                anchorElBoard: null,
                openCollapseDashboards: false
            })
        }
    }

    componentDidMount() {
        this.loadObjectives()
        this.interval = setInterval(() => this.setState({ dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")) }), 300000);
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    loadObjectives = () => {
        setTimeout(() => {
            const node = document.getElementById(this.state.activeObjetivoId);
            if (node) {
                node.focus();
            }
        });

        const {special}=this.state
        let token = sessionStorage.getItem('key')
        let user_id = sessionStorage.getItem('user')
        if(special===true){
            fetch(api_host + `/reporte/online/indicadores/getObjetivesType/?user=${user_id}&token=${token}&type=especiales`)
            .then(response => response.json())
            .then(myJson => {
                if (myJson.status === 1 || myJson.status === 5) {
                    localStorage.setItem('isAuthenticated', false);   
                } else {
                    myJson=(myJson.map(data => ({
                        ...data,
                        nombre: data.nombre.replaceAll("/", "|")
                    })))
                    this.props.callbackFromParent(myJson)
                    sessionStorage.setItem('special', "true")
                    sessionStorage.setItem('specials', JSON.stringify(myJson))
                    this.setState({
                        listObjectivesSpecials:myJson,
                        cargando:false,
                        nameSide:"R.Especiales"
                    });  
                }
            })
        }else if(sessionStorage.getItem('special')==="true"){
            this.props.callbackFromParent(JSON.parse(sessionStorage.getItem('specials')))
            this.setState({
                listObjectivesSpecials:JSON.parse(sessionStorage.getItem('specials')),
                special:true,
                cargando:false,
                nameSide:"R.Especiales"
            });
        }else{
            if(!sessionStorage.getItem('horarios')){
                fetch(api_host + `/reporte/general/horarios/?token=${token}&hour=business&start=${new Date().getTime()}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                    } else {
                        //Procesa la Data Recibida
                        sessionStorage.setItem('horarios', JSON.stringify(myJson))
                    }
                })
            }
            
    
            if(sessionStorage.getItem("listsLoads")==="true"){
                this.updateFromCache()
            }else{
                getObjectivesIgnoreCache(user_id, token).then(data=>{
                    if (data.status === 1 || data.status === 5) {
                        localStorage.setItem('isAuthenticated', false);   
                    } else {
                        let dataSeries = []
                        let dataServices = []
                        let checked = []
                        dataServices.push('Todos')
                        checked.push(0)
                        Object.keys(data).map((keyType) => {
                            if (keyType != 'Services' && keyType != 'ServicesUnified' && keyType != 'NoMonitoringPartial') {
                                let serie = data[keyType]
                                Object.keys(serie).map((key) => {
                                    serie[key].nombre=(serie[key].nombre.replaceAll("/", "|"))
                                    dataSeries.unshift(serie[key])
                                })
                            } else if (keyType == 'ServicesUnified') {                            
                                let serie = data[keyType]
                                Object.keys(serie).map((key) => {
                                    checked.push(parseInt(key)+1)
                                    dataServices.push(serie[key])
                                })
                            }
                        })
                        if (this.props.callbackFromParent) {
                            this.props.callbackFromParent(data)
                        }
                        localStorage.setItem('isLoadObjectiveList', true);
                        var order = {'Downtime': 1, "Parcial": 2, "Uptime": 3, "No monitoreo": 4};
                        dataSeries.sort(function (a, b) {
                            var priorityA = order[a.estado] || Infinity;
                            var priorityB = order[b.estado] || Infinity;

                            var nombreA = (a.nombre).toLowerCase()
                            var nombreB = (b.nombre).toLowerCase()

                            if (priorityA < priorityB) return -1;
                            if (priorityA > priorityB) return 1;

                            if (nombreA < nombreB) return -1;
                            if (nombreA > nombreB) return 1;
                            return 0;
                        })
                        this.setState({
                            listaObjetivos: (data),
                            listaObjetivosOnline: dataSeries,
                            filteredListObjectives: dataSeries,
                            listaServicios: dataServices,
                            cargando: false,
                            checked: checked,
                            checkedBase: checked.length,
                            nameSide:"Monitoreos"
                        });
                        sessionStorage.setItem("listaData",JSON.stringify(data))
                        sessionStorage.setItem("listaObjetivosOnline",JSON.stringify(dataSeries))
                        sessionStorage.setItem("dataServices",JSON.stringify(dataServices))
                        sessionStorage.setItem("checked",JSON.stringify(checked))
                        sessionStorage.setItem("listsLoads",true)
                    }
                })
                .catch((error) => {
                    reportFetchError('Sidebar', error)
                    this.setState({ cargando: false })
                })
            }
        }
    }

    handleClick = event => {
        this.setState({
            anchorEl: event.currentTarget
        });
    };

    handleClose = () => {
        this.setState({
            anchorEl: null
        });
    };
    handleClickModal = event => {            
        if (this.state.openModal == false){
            this.setState({
                openModal: true,
            })
        }        
    };
    
    handleCloseModal = event => {   
        this.setState({
            openModal: false,  
        })
    };

    handleClickUpdate = event => {   
        sessionStorage.setItem("listsLoads", false)
        sessionStorage.setItem("listsLoadsDisponibilidad",false)
        this.setState({
            cargando: true,
        })
        this.loadObjectives()
    };

    handleToggle = value => () => {
        const {checked, listaServicios, listaObjetivosOnline, checkedBase} = this.state
        const currentIndex = checked.indexOf(parseInt(value));
        const newChecked = [...checked];
        var check = false

        if (parseInt(value) == 0){            
            if (currentIndex === -1) {      
                newChecked.splice(0, checkedBase);
                Object.keys(listaServicios).map((keyCheck, value) => { 
                    newChecked.push(parseInt(value));
                })
            } else {
                newChecked.splice(0, checkedBase);
            }
        } else {          
            if (currentIndex === -1) {
                newChecked.push(parseInt(value));
                if ((checkedBase - 1) == newChecked.length )
                    newChecked.push(0)
            } else {
                newChecked.splice(currentIndex, 1);
                if (checked.indexOf(0) !== -1) {
                    newChecked.splice(newChecked.indexOf(0), 1);
                }            
            }

        }  
            
        let filteredSerie = [] 

        Object.keys(newChecked).map((keyCheck, value) => {

            let service = listaServicios[newChecked[parseInt(value)]]

            Object.keys(listaObjetivosOnline).map((keyObj, value) => {
                if (listaObjetivosOnline[keyObj].nombre_servicio_unificado == service) {
                    
                    filteredSerie.push(listaObjetivosOnline[keyObj])
                }    
            })  
        })
        filteredSerie.sort(function (a, b) {
            var priorityA = a.orden || Infinity;
            var priorityB = b.orden || Infinity;

            var nombreA = (a.nombre).toLowerCase()
            var nombreB = (b.nombre).toLowerCase()

            if (priorityA < priorityB) return -1;
            if (priorityA > priorityB) return 1;

            if (nombreA < nombreB) return -1;
            if (nombreA > nombreB) return 1;
            return 0;
        });
        if (checkedBase == newChecked.length) {
            check = false
        } else {
            check = true
        }

        this.setState({
            checked: newChecked,
            filteredListObjectives: filteredSerie,
            isBallotIconChecked: check
        });
    };

    toggleReport =()=>{
        if(sessionStorage.getItem("special")==="true"){
            sessionStorage.setItem("special", "false")
        }
        this.setState({
            special: !this.state.special,
            cargando:true
        });
    }

    handleCollapseClick = event => {
        const {openCollapse } = this.state
        this.setState({
            openCollapse: !openCollapse,
            anchorElSupport: event.currentTarget
        })
        saveSidebarOptions({openCollapse: !openCollapse});
    };

    handleCollapseMonitorClick = event => {
        const {openCollapseMonitor } = this.state
        this.setState({
            openCollapseMonitor: !openCollapseMonitor,
            anchorElMonitor: event.currentTarget
        })
        saveSidebarOptions({openCollapseMonitor: !openCollapseMonitor});

        setTimeout(() => {
            const node = document.getElementById(this.state.activeObjetivoId);
            if (node) {
                node.focus();
            }
        });
    };

    handleCollapseBoard = event => {
        const {openCollapseBoard } = this.state
        this.setState({
            openCollapseBoard: !openCollapseBoard,
            anchorElBoard: event.currentTarget
        })
        saveSidebarOptions({openCollapseBoard: !openCollapseBoard});
    };

    handleClickBtnFiltroEtiquetas = event => {
        this.setState({
            anchorElEtiquetas: event.currentTarget
        });
    };

    handleCollapseDashboards = event => {
        const {openCollapseDashboards } = this.state
        this.setState({
            openCollapseDashboards: !openCollapseDashboards,
            anchorElDashboard: event.currentTarget
        })
        saveSidebarOptions({openCollapseDashboards: !openCollapseDashboards});
    };

    updateFromCache = () => {
        var dataSession=JSON.parse(sessionStorage.getItem("listaData"))
        var seriesSession=JSON.parse(sessionStorage.getItem("listaObjetivosOnline"))
        var servicesSession=JSON.parse(sessionStorage.getItem("dataServices"))
        var checked=JSON.parse(sessionStorage.getItem("checked"))
        if (this.props.callbackFromParent) {
            this.props.callbackFromParent(dataSession)
        }
        if(sessionStorage.getItem("isLoadAvailability")==="true"){
            var dataUptime=(JSON.parse(sessionStorage.getItem("listaDataAvailability")))
            var UptimeObjs=[]
            var DownObjs=[]
            var PartialObj=[]
            dataUptime.map(Obj=>{
                
                if(Obj.estado==="Uptime"){
                    UptimeObjs.push(Obj)
                }else if(Obj.estado==="Downtime"){
                    DownObjs.push(Obj)
                }else if(Obj.estado==="Parcial"){
                    PartialObj.push(Obj)
                }
            })
            UptimeObjs.sort(function (a, b) {
                return (a.disponibilidad - b.disponibilidad);
            })
            DownObjs.sort(function (a, b) {
                return (a.disponibilidad - b.disponibilidad);
            })
            PartialObj.sort(function (a, b) {
                return (a.disponibilidad - b.disponibilidad);
            })
            UptimeObjs.sort(function (a, b) {
                var nombreA = (a.nombre).toLowerCase()
                var nombreB = (b.nombre).toLowerCase()
                if (nombreA < nombreB) return -1;
                if (nombreA > nombreB) return 1;
                return 0;
            })
            DownObjs.sort(function (a, b) {
                var nombreA = (a.nombre).toLowerCase()
                var nombreB = (b.nombre).toLowerCase()
                if (nombreA < nombreB) return -1;
                if (nombreA > nombreB) return 1;
                return 0;
            })
            PartialObj.sort(function (a, b) {
                var nombreA = (a.nombre).toLowerCase()
                var nombreB = (b.nombre).toLowerCase()
                if (nombreA < nombreB) return -1;
                if (nombreA > nombreB) return 1;
                return 0;
            })
            dataSession.Uptime=UptimeObjs
            dataSession.Downtime=DownObjs
            dataSession.Partial=PartialObj
            seriesSession=[].concat(DownObjs, PartialObj, UptimeObjs, dataSession.NoMonitoring)
            
        }
        this.setState({
            listaObjetivos: (dataSession),
            listaObjetivosOnline: seriesSession,
            filteredListObjectives: seriesSession,
            listaServicios: servicesSession,
            cargando: false,
            checked: checked,
            checkedBase: checked.length,
            nameSide:"Monitoreos"
        }); 
    }

    updateEtiquetas = (etiquetas, filterType) => {
        this.setState({filterTags: etiquetas, filterTagsType: filterType})
        sidebarFiltersTags.saveSidebarFilterTags(etiquetas)
        sidebarFiltersTags.saveFilterType(filterType)
    }

    objectivesListFilteredByTags = () => {
        const filterTagsId = this.state.filterTags.map(etiqueta => etiqueta.etiqueta_id)
        if (filterTagsId.length === 0) return this.state.filteredListObjectives
        const filtered = this.state.filteredListObjectives.filter(obj => {
            if (!obj.Etiquetas) return false
            let tieneEtiquetas = true

            if (this.state.filterTagsType === "AND") {
                for (const id of filterTagsId) {
                    if (!obj.Etiquetas.find(et => et.etiqueta_id === id)) {
                        tieneEtiquetas = false
                        break;
                    }
                }
            } else {
                tieneEtiquetas = obj.Etiquetas.filter(et => filterTagsId.includes(et.etiqueta_id)).length > 0
            }
            return tieneEtiquetas
        })
        return filtered
    }

    render() {
    const { classes, className, collapsed  } = this.props;
    const t = (this.props && this.props.t) ? this.props.t : (s => s);
        const { listaObjetivos, listaServicios, cargando, anchorEl, checked, isBallotIconChecked, openModal, profileId, 
            special, listObjectivesSpecials, openCollapse, openCollapseMonitor, openCollapseBoard, anchorElSupport, anchorElMonitor, anchorElBoard,
            anchorElEtiquetas, openCollapseDashboards, anchorElDashboard, clienteId, isAdmin} = this.state
        const rootClassName = classNames(classes.root, className);
        const open = Boolean(anchorEl);
        const profileNoSpecial=[3,6,7,12]
        const filteredListObjectives = this.objectivesListFilteredByTags()
        // Crea un Set a partir del array, eliminando duplicados
        const setSinDuplicados = new Set(filteredListObjectives.map(obj => JSON.stringify(obj)));
        // Convierte el Set de nuevo a un array
        const filteredListObjectivesNoDuplicates = Array.from(setSinDuplicados).map(str => JSON.parse(str));
        const objectiveConfigIsEnabled = objectiveConfigProfileAccess.includes(Number(profileId))
        const syncAvailabilityIsEnabled = sessionStorage.getItem('acceso_dashboard_pichincha') === 'true'
        const isMovistarPeruClient = clientAccessHelpers.isMovistarPeruClient()
        return (
            <nav className={rootClassName}>
                <div className={collapsed ? classes.logoWrapperCollapsed : classes.logoWrapperNoCollapsed} >
                    <Link
                        className={classes.logoLink}
                        to={{
                            pathname: '/home',
                            search: getQueryParams()
                        }}
                    >
                        <img
                            alt="Atentus logo"
                            className={classes.logoImage}
                            src={collapsed ? "/images/logos/atentus-isotipo.svg" :"/images/logos/logo-atentus-gris.svg"}
                        />
                    </Link>
                </div>
                <Divider className={classes.profileDivider} />
                <List
                    component="div"
                    disablePadding
                >
                    <ListItem
                        activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                        className={collapsed ? classes.listItemCollapsed : classes.listItem}
                        onClick={this.props.handleCollapsedChange}
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <Tooltip title={t('sidebar.menu')} placement="top-start">
                                <MenuIcon/>
                            </Tooltip>
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary={t('sidebar.menu')}
                        />
                    </ListItem>
                    <ListItem
                        activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                        className={collapsed ? classes.listItemCollapsed : classes.listItem}
                        component={NavLink}
                        to={{
                            pathname: '/home',
                            search: getQueryParams(),
                            state: {
                                Graph:1
                            }
                        }}
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <Tooltip title={t('sidebar.home.tooltip')} placement="top-start">
                                <HomeIcon />
                            </Tooltip>
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary={t('sidebar.home')}
                        />
                    </ListItem>
                    <ListItem onClick={this.handleCollapseBoard}
                            activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                            className={collapsed ? classes.listItemCollapsed : classes.listItem}>
                        <ListItemIcon className={classes.listItemIcon}>
                            <Tooltip title={t('sidebar.boards.tooltip')} placement="top-start">
                                <DashboardIcon />
                            </Tooltip>
                        </ListItemIcon>
                        {collapsed ? null :
                            <ListItemText
                                classes={{ primary: classes.listItemText }}
                                primary={t('sidebar.boards')}
                            />}
                        {openCollapseBoard ? <ExpandLessIcon style={{color:'white'}} /> : <ExpandMoreIcon style={{color:'white'}} />}
                    </ListItem>
                    <List
                        component="div"
                        disablePadding
                    >
                        <Collapse in={openCollapseBoard} timeout="auto" unmountOnExit>
                            {/* si el sidebar esta 'collapse', muestra el menu en un popover, sino se muestra normal  */}
                            {collapsed ?
                                <Popover
                                    PaperProps={{ style: { width: '271px',  backgroundColor: '#0b1738' },}}
                                    open={openCollapseBoard} onClose={this.handleCollapseBoard}
                                    anchorEl={anchorElBoard}
                                    anchorOrigin={{vertical: 'top', horizontal: 'right',}}
                                    transformOrigin={{vertical: 'top', horizontal: 'left',}}
                                    >
                                        {clienteId === '1' || isAdmin ?
                                        <ListItem
                                            activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                            className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                            component={NavLink}
                                            estado="dos"
                                            to={{
                                                pathname: `/boards`,
                                                search: getQueryParams(),
                                                state: {
                                                    Graph:0
                                                }
                                            }}
                                        >
                                            <ListItemIcon className={classes.listItemIcon}>
                                                    <Tooltip title={t('sidebar.boards.tooltip')} placement="top-start">
                                                    <DashboardCustomizeIcon />
                                                </Tooltip>
                                            </ListItemIcon>
                                            <ListItemText
                                                classes={{ primary: classes.listItemText }}
                                                primary={t('sidebar.boards_favorites')}
                                            />
                                        </ListItem>
                                        : null}
                                        <ListItem
                                            activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                            className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                            component={NavLink}
                                            to={{
                                                pathname: `/quickview`,
                                                search: getQueryParams(),
                                                state: {
                                                    Graph:1
                                                }
                                            }}
                                        >
                                            <ListItemIcon className={classes.listItemIcon}>
                                                    <Tooltip title={t('sidebar.quickview.tooltip')} placement="top-start">
                                                    <QuickreplyIcon />
                                                </Tooltip>
                                            </ListItemIcon>
                                            <ListItemText
                                                classes={{ primary: classes.listItemText }}
                                                primary={t('sidebar.quickview')}
                                            />
                                        </ListItem>
                                        <ListItem
                                            activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                            className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                            component={NavLink}
                                            estado="dos"
                                            to={{
                                                pathname: `/estadoOperativo`,
                                                search: getQueryParams(),
                                                state: {
                                                    Graph:2
                                                }
                                            }}
                                        >
                                            <ListItemIcon className={classes.listItemIcon}>
                                                    <Tooltip title={t('sidebar.operational_state.tooltip')} placement="top-start">
                                                    <WorkspacesIcon />
                                                </Tooltip>
                                            </ListItemIcon>
                                            <ListItemText
                                                classes={{ primary: classes.listItemText }}
                                                primary={t('sidebar.operational_state')}
                                            />
                                        </ListItem>
                                        <ListItem
                                            activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                            className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                            component={NavLink}
                                            estado="cuatro"
                                            to={{
                                                pathname: `/generalStatus`,
                                                search: getQueryParams(),
                                                state: {
                                                    Graph:4
                                                }
                                            }}
                                        >
                                            <ListItemIcon className={classes.listItemIcon}>
                                                    <Tooltip title={t('sidebar.general_state.tooltip')} placement="top-start">
                                                    <PublicIcon />
                                                </Tooltip>
                                            </ListItemIcon>
                                            <ListItemText
                                                classes={{ primary: classes.listItemText }}
                                                primary={t('sidebar.general_state')}
                                            />
                                        </ListItem>
                                        <ListItem
                                            activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                            className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                            component={NavLink}
                                            to={{
                                                pathname: `/quickviewisplights`,
                                                search: getQueryParams(),
                                                state: {
                                                    Graph:1
                                                }
                                            }}
                                        >
                                            <ListItemIcon className={classes.listItemIcon}>
                                                    <Tooltip title={t('sidebar.quickview_isp.tooltip')} placement="top-start">
                                                    <TrafficIcon />
                                                </Tooltip>
                                            </ListItemIcon>
                                            <ListItemText
                                                classes={{ primary: classes.listItemText }}
                                                primary={t('sidebar.quickview_isp')}
                                            />
                                        </ListItem>
                                        {sessionStorage.getItem('acceso_metricas') === 'true' && (
                                        <ListItem
                                            activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                            className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                            component={NavLink}
                                            to={{
                                                pathname: `/metricas`,
                                                search: getQueryParams(),
                                                state: {
                                                    Graph:1
                                                }
                                            }}
                                        >
                                            <ListItemIcon className={classes.listItemIcon}>
                                                    <Tooltip title={t('sidebar.indicadores.tooltip')} placement="top-start">
                                                    <InsightsIcon />
                                                </Tooltip>
                                            </ListItemIcon>
                                            <ListItemText
                                                classes={{ primary: classes.listItemText }}
                                                primary={t('sidebar.indicadores')}
                                            />
                                        </ListItem>
                                        )}
                                        {isMovistarPeruClient && (
                                        <ListItem
                                            activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                            className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                            component={NavLink}
                                            to={{
                                                pathname: `/sentimiento`,
                                                search: getQueryParams(),
                                                state: {
                                                    Graph:1
                                                }
                                            }}
                                        >
                                            <ListItemIcon className={classes.listItemIcon}>
                                                    <Tooltip title={t('sidebar.sentimiento.tooltip', { defaultValue: 'Sentimiento' })} placement="top-start">
                                                    <EmojiEmotionsIcon />
                                                </Tooltip>
                                            </ListItemIcon>
                                            <ListItemText
                                                classes={{ primary: classes.listItemText }}
                                                primary={t('sidebar.sentimiento', { defaultValue: 'Sentimiento' })}
                                            />
                                        </ListItem>
                                        )}
                                </Popover>
                            : <List>
                                {clienteId === '1' || isAdmin ?
                                <ListItem
                                    activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                    className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                    component={NavLink}
                                    estado="dos"
                                    to={{
                                        pathname: `/boards`,
                                        search: getQueryParams(),
                                        state: {
                                            Graph:0
                                        }
                                    }}
                                >
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <Tooltip title={t('sidebar.boards.tooltip')} placement="top-start">
                                            <DashboardCustomizeIcon />
                                        </Tooltip>
                                    </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: classes.listItemText }}
                                        primary={t('sidebar.boards_favorites')}
                                    />
                                </ListItem>
                                :null}
                                <ListItem
                                    activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                    className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                    component={NavLink}
                                    to={{
                                        pathname: `/quickview`,
                                        search: getQueryParams(),
                                        state: {
                                            Graph:1
                                        }
                                    }}
                                >
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <Tooltip title={t('sidebar.quickview.tooltip')} placement="top-start">
                                            <QuickreplyIcon />
                                        </Tooltip>
                                    </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: classes.listItemText }}
                                        primary={t('sidebar.quickview')}
                                    />
                                </ListItem>
                                <ListItem
                                    activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                    className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                    component={NavLink}
                                    estado="dos"
                                    to={{
                                        pathname: `/estadoOperativo`,
                                        search: getQueryParams(),
                                        state: {
                                            Graph:2
                                        }
                                    }}
                                >
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <Tooltip title={t('sidebar.operational_state.tooltip')} placement="top-start">
                                            <WorkspacesIcon />
                                        </Tooltip>
                                    </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: classes.listItemText }}
                                        primary={t('sidebar.operational_state')}
                                    />
                                </ListItem>
                                <ListItem
                                    activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                    className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                    component={NavLink}
                                    estado="cuatro"
                                    to={{
                                        pathname: `/generalStatus`,
                                        search: getQueryParams(),
                                        state: {
                                            Graph:4
                                        }
                                    }}
                                >
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <Tooltip title={t('sidebar.general_state.tooltip')} placement="top-start">
                                            <PublicIcon />
                                        </Tooltip>
                                    </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: classes.listItemText }}
                                        primary={t('sidebar.general_state')}
                                    />
                                </ListItem>
                                <ListItem
                                    activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                    className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                    component={NavLink}
                                    to={{
                                        pathname: `/quickviewisplights`,
                                        search: getQueryParams(),
                                        state: {
                                            Graph:1
                                        }
                                    }}
                                >
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <Tooltip title={t('sidebar.quickview_isp.tooltip')} placement="top-start">
                                            <TrafficIcon />
                                        </Tooltip>
                                    </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: classes.listItemText }}
                                        primary={t('sidebar.quickview_isp')}
                                    />
                                </ListItem>
                                {sessionStorage.getItem('acceso_metricas') === 'true' && (
                                <ListItem
                                    activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                    className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                    component={NavLink}
                                    to={{
                                        pathname: `/metricas`,
                                        search: getQueryParams(),
                                        state: {
                                            Graph:1
                                        }
                                    }}
                                >
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <Tooltip title={t('sidebar.indicadores.tooltip')} placement="top-start">
                                            <InsightsIcon />
                                        </Tooltip>
                                    </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: classes.listItemText }}
                                        primary={t('sidebar.indicadores')}
                                    />
                                </ListItem>
                                )}
                                {isMovistarPeruClient && (
                                <ListItem
                                    activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                    className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                    component={NavLink}
                                    to={{
                                        pathname: `/sentimiento`,
                                        search: getQueryParams(),
                                        state: {
                                            Graph:1
                                        }
                                    }}
                                >
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <Tooltip title={t('sidebar.sentimiento.tooltip', { defaultValue: 'Sentimiento' })} placement="top-start">
                                            <EmojiEmotionsIcon />
                                        </Tooltip>
                                    </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: classes.listItemText }}
                                        primary={t('sidebar.sentimiento', { defaultValue: 'Sentimiento' })}
                                    />
                                </ListItem>
                                )}
                                </List>
                            }
                        </Collapse>
                    </List>
                    {/* Dasboards Extendidos */}
                    <Divider className={classes.listDivider} />
                    <ListItem onClick={this.handleCollapseDashboards}
                        activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                        className={collapsed ? classes.listItemCollapsed : classes.listItem}>
                    <ListItemIcon className={classes.listItemIcon}>
                        <Tooltip title={t('sidebar.dashboards_extended.tooltip')} placement="top-start">
                            <AssessmentIcon />
                        </Tooltip>
                    </ListItemIcon>
                    {collapsed ? null :
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary={t('sidebar.dashboards_extended')}
                        />
                    }
                    {openCollapseDashboards ? <ExpandLessIcon style={{color:'white'}} /> : <ExpandMoreIcon style={{color:'white'}} />}
                    </ListItem>
                    <List
                        component="div"
                        disablePadding
                    >
                        <Collapse in={openCollapseDashboards} timeout="auto" unmountOnExit>
                            {collapsed ?
                                <Popover
                                    PaperProps={{ style: { width: '271px',  backgroundColor: '#0b1738' },}}
                                    open={openCollapseDashboards} onClose={this.handleCollapseDashboards}
                                    anchorEl={anchorElDashboard}
                                    anchorOrigin={{vertical: 'top', horizontal: 'right',}}
                                    transformOrigin={{vertical: 'top', horizontal: 'left',}}
                                    >
                                    <ListItem
                                        activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                        className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                        component={NavLink}
                                        to={{
                                            pathname: `/comparisonObjectives`,
                                            search: getQueryParams(),
                                            state: {
                                                Graph:1
                                            }
                                        }}
                                    >
                                        <ListItemIcon className={classes.listItemIcon}>
                                            <Tooltip title={t('sidebar.compare_objectives.tooltip')} placement="top-start">
                                                <CompareArrowsIcon />
                                            </Tooltip>
                                        </ListItemIcon>
                                            <ListItemText
                                                classes={{ primary: classes.listItemText }}
                                                primary={t('sidebar.compare_objectives')}
                                            />
                                    </ListItem>
                                    <ListItem
                                        activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                        className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                        component={NavLink}
                                        estado="cuatro"
                                        to={{
                                            pathname: `/disponibilidadumbral`,
                                            search: getQueryParams(),
                                            state: {
                                                Graph:4
                                            }
                                        }}
                                    >
                                        <ListItemIcon className={classes.listItemIcon}>
                                            <Tooltip title={t('sidebar.flashboard_visibility.tooltip')} placement="top-start">
                                                <LeaderboardIcon />
                                            </Tooltip>
                                        </ListItemIcon>
                                            <ListItemText
                                                classes={{ primary: classes.listItemText }}
                                                primary={t('sidebar.flashboard_visibility')}
                                            />
                                    </ListItem>
                                    <ListItem
                                        activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                        className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                        component={NavLink}
                                        estado="cuatro"
                                        to={{
                                            pathname: `/apdex`,
                                            search: getQueryParams(),
                                            state: {
                                                Graph:4
                                            }
                                        }}
                                    >
                                        <ListItemIcon className={classes.listItemIcon}>
                                            <Tooltip title={t('sidebar.apdex.tooltip')} placement="top-start">
                                                <SpeedIcon />
                                            </Tooltip>
                                        </ListItemIcon>
                                        <ListItemText
                                            classes={{ primary: classes.listItemText }}
                                            primary={t('sidebar.apdex')}
                                        />
                                    </ListItem>
                                    <ListItem
                                        activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                        className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                        component={NavLink}
                                        estado="cinco"
                                        to={{
                                            pathname: `/heatmap`,
                                            state: {
                                                Graph:5
                                            },
                                            search: getQueryParams(),
                                        }}
                                    >
                                        <ListItemIcon className={classes.listItemIcon}>
                                            <Tooltip title={t('sidebar.heatmap.tooltip')} placement="top-start">
                                                <CalendarViewMonthIcon />
                                            </Tooltip>
                                        </ListItemIcon>
                                        <ListItemText
                                            classes={{ primary: classes.listItemText }}
                                            primary={t('sidebar.heatmap')}
                                        />
                                    </ListItem>
                                </Popover>
                                :<List>
                                    <ListItem
                                        activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                        className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                        component={NavLink}
                                        to={{
                                            pathname: `/comparisonObjectives`,
                                            search: getQueryParams(),
                                            state: {
                                                Graph:1
                                            }
                                        }}
                                    >
                                        <ListItemIcon className={classes.listItemIcon}>
                                            <Tooltip title={t('sidebar.compare_objectives.tooltip')} placement="top-start">
                                                <CompareArrowsIcon />
                                            </Tooltip>
                                        </ListItemIcon>
                                        <ListItemText
                                            classes={{ primary: classes.listItemText }}
                                            primary={t('sidebar.compare_objectives')}
                                        />
                                    </ListItem>
                                    <ListItem
                                        activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                        className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                        component={NavLink}
                                        estado="cuatro"
                                        to={{
                                            pathname: `/disponibilidadumbral`,
                                            search: getQueryParams(),
                                            state: {
                                                Graph:4
                                            }
                                        }}
                                    >
                                        <ListItemIcon className={classes.listItemIcon}>
                                            <Tooltip title={t('sidebar.flashboard_visibility.tooltip')} placement="top-start">
                                                <LeaderboardIcon/>
                                            </Tooltip>
                                        </ListItemIcon>
                                        <ListItemText
                                            classes={{ primary: classes.listItemText }}
                                            primary={t('sidebar.flashboard_visibility')}
                                        />
                                    </ListItem>
                                    <ListItem
                                        activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                        className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                        component={NavLink}
                                        to={{
                                            pathname: `/apdex`,
                                            search: getQueryParams(),
                                            state: {
                                                Graph:1
                                            }
                                        }}
                                    >
                                        <ListItemIcon className={classes.listItemIcon}>
                                            <Tooltip title={t('sidebar.apdex.tooltip')} placement="top-start">
                                                <SpeedIcon />
                                            </Tooltip>
                                        </ListItemIcon>
                                        <ListItemText
                                            classes={{ primary: classes.listItemText }}
                                            primary={t('sidebar.apdex')}
                                        />
                                    </ListItem>
                                    <ListItem
                                        activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                                        className={collapsed ? classes.listItemCollapsed : classes.listItem}
                                        component={NavLink}
                                        to={{
                                            pathname: `/heatmap`,
                                            state: {
                                                Graph:1
                                            },
                                            search: getQueryParams(),
                                        }}
                                    >
                                        <ListItemIcon className={classes.listItemIcon}>
                                            <Tooltip title={t('sidebar.heatmap.tooltip')} placement="top-start">
                                                <CalendarViewMonthIcon />
                                            </Tooltip>
                                        </ListItemIcon>
                                        <ListItemText
                                            classes={{ primary: classes.listItemText }}
                                            primary={t('sidebar.heatmap')}
                                        />
                                    </ListItem>
                                </List>
                            }
                        </Collapse>
                    </List>
                    <Divider className={classes.listDivider} />
                    <ListItem onClick={this.handleCollapseMonitorClick}
                            activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                            className={collapsed ? classes.listItemCollapsed : classes.listItem}>
                        <ListItemIcon className={classes.listItemIcon}>
                            <Tooltip title={t('sidebar.monitorings.tooltip')} placement="top-start">
                                <VisibilityIcon />
                            </Tooltip>
                        </ListItemIcon>
                        {collapsed ? null :
                            <ListItemText
                                classes={{ primary: classes.listItemText }}
                                primary={t('sidebar.monitorings')}
                            />}
                        {openCollapseMonitor ? <ExpandLessIcon style={{color:'white'}} /> : <ExpandMoreIcon style={{color:'white'}} />}
                    </ListItem>
                    <Collapse in={openCollapseMonitor} timeout="auto" unmountOnExit>
                        {collapsed ? <Popover
                                        PaperProps={{ style: { width: '271px',  backgroundColor: '#333333' },}}
                                        open={openCollapseMonitor} onClose={this.handleCollapseMonitorClick}
                                        anchorEl={anchorElMonitor}
                                        anchorOrigin={{vertical: 'top', horizontal: 'right',}}
                                        transformOrigin={{vertical: 'top', horizontal: 'left',}}
                                        >
                                            <List
                                                component="div"
                                                disablePadding
                                                subheader={
                                                    <div style={{backgroundColor: '#0b1738', textAlign: 'right', padding: '15px', paddingBlock:'4px' }}>
                                                            <Icon onClick={this.toggleReport} style={{ display:"inline-block", width:"35px"}}>
                                                                {profileNoSpecial.includes(profileId)===false?
                                                                special?
                                                                    <Tooltip title={t('sidebar.monitorings.tooltip')} placement="top-start">
                                                                        <Typography style={{fontWeight: 'bold', color:"white", fontSize:"18px", paddingTop:"3px", paddingLeft:"6px", cursor: 'pointer'}}>M</Typography>
                                                                    </Tooltip>
                                                                    :
                                                                    <Tooltip title={t('sidebar.monitorings_special.tooltip')} placement="top-start">
                                                                        <Typography style={{fontWeight: 'bold', color:"white", fontSize:"18px", paddingTop:"3px", paddingLeft:"3px", cursor: 'pointer'}}>R.E.</Typography>
                                                                    </Tooltip>
                                                                :null

                                                                }
                                                            </Icon>

                                                            <Tooltip title={t('sidebar.update')} placement="top-start">
                                                                <UpdateIcon  variant="contained" onClick={this.handleClickUpdate} className={classes.ballotIcon} />
                                                            </Tooltip>
                                                            <Tooltip title={t('sidebar.summary_monitorings')} placement="top-start">
                                                                <BarChartOutlinedIcon variant="contained" onClick={this.handleClickModal} className={classes.ballotIcon}/> 
                                                            </Tooltip>
                                                            <Tooltip title={t('sidebar.filter_service')} placement="top-start">
                                                                {isBallotIconChecked ?
                                                                    <FilterListIcon variant="contained" onClick={this.handleClick} className={classes.ballotIconChecked}/> :
                                                                    <FilterListIcon variant="contained" onClick={this.handleClick} className={classes.ballotIcon} />
                                                                }
                                                            </Tooltip>
                                                            <Tooltip title={t('sidebar.filter_tags')} placement="top-start">
                                                                <LocalOfferIcon
                                                                    variant="contained"
                                                                    className={this.state.filterTags.length ? classes.ballotIconChecked : classes.ballotIcon}
                                                                    onClick={this.handleClickBtnFiltroEtiquetas}
                                                                />
                                                            </Tooltip>
                                                            <div>
                                                                <Modal
                                                                    aria-labelledby="simple-modal-title"
                                                                    aria-describedby="simple-modal-description"
                                                                    open={openModal}
                                                                    onClose={this.handleCloseModal}
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                    }}
                                                                    disableAutoFocus={true}
                                                                    disableEnforceFocus={true}
                                                                    closeAfterTransition
                                                                    BackdropComponent={Backdrop}
                                                                    BackdropProps={{
                                                                        timeout: 500,
                                                                    }}
                                                                >
                                                                    <Fade in={openModal}>
                                                                        <PerfectScrollbar>
                                                                        <div className={classes.modal}>
                                                                            <SummaryObjectives params={listaObjetivos} handleClose={this.handleCloseModal} isForModal={true}/>
                                                                        </div>
                                                                        </PerfectScrollbar>
                                                                    </Fade>
                                                                </Modal>
                                                            </div>

                                                            <Popover open={open} onClose={this.handleClose}
                                                                    anchorEl={anchorEl}
                                                                    anchorOrigin={{vertical: 'top', horizontal: 'right',}}
                                                                    transformOrigin={{vertical: 'center', horizontal: 'left',}}>
                                                                <PerfectScrollbar>
                                                                    <Paper style={{
                                                                        minHeight: 50,
                                                                        maxHeight: 400,
                                                                        overflow: 'auto',
                                                                        }}
                                                                        className={classes.customScrollBar}
                                                                    >
                                                                        <List   disablePadding>
                                                                            {Object.keys(listaServicios).map(key => (
                                                                                    <ListItem
                                                                                        component="div"
                                                                                        key={key}
                                                                                        role={undefined}
                                                                                        dense button
                                                                                        onClick={this.handleToggle(key)}
                                                                                    >
                                                                                        <ListItemIcon className={classes.listItemIcon} >
                                                                                            <Checkbox
                                                                                                style ={{
                                                                                                    color: "#f57000",
                                                                                                }}
                                                                                                edge="start"
                                                                                                checked={checked.indexOf(parseInt(key)) !== -1}
                                                                                                tabIndex={-1}
                                                                                                disableRipple
                                                                                                inputProps={{ 'aria-labelledby': key }}
                                                                                            />
                                                                                        </ListItemIcon>
                                                                                        <ListItemText id={key} primary={listaServicios[key]} />
                                                                                    </ListItem>

                                                                            ))}
                                                                        </List>
                                                                    </Paper>
                                                                </PerfectScrollbar>
                                                            </Popover>
                                                            </div>
                                                }
                                            >
                                                <Paper style={{ minHeight: 50,
                                                                maxHeight: 400, 
                                                                overflow: 'auto', 
                                                                overflowX: 'hidden',
                                                                backgroundColor: '#0b1738',

                                                            }}
                                                        className={classes.customScrollBar}>
                                                    {cargando ?
                                                        <div className={classes.profile}>
                                                            <CircularProgress />
                                                        </div>
                                                        :
                                                        special?
                                                        listObjectivesSpecials.map((keyObj) => (
                                                            <ListItem
                                                                key={keyObj.objetivo_id}
                                                                className={classes.listItem}
                                                                activeClassName={classes.activeListItem}
                                                                component={NavLink}
                                                                to={{
                                                                    pathname: `/especial/${keyObj.objetivo_id}/${keyObj.nombre}`,
                                                                    search: getQueryParams(),
                                                                    state: {
                                                                        fromObjective: keyObj
                                                                    }
                                                                }}
                                                            >
                                                                <ListItemIcon className={classes.listItemIcon}>
                                                                    <TimelineIcon style={{color:"#3eeacc"}} />
                                                                </ListItemIcon>
                                                                <ListItemText
                                                                    classes={{ primary: classes.listItemText }}
                                                                    primary={keyObj.nombre}
                                                                    //Cambia estructura, para agregar estilo custom directo
                                                                    secondary={<div style={{ color: '#b2b2b2',  fontWeight: 'bold', }}>{keyObj.nombre_servicio}</div>}
                                                                />
                                                            </ListItem>
                                                            ))
                                                        :
                                                        Object.keys(filteredListObjectivesNoDuplicates).map((keyObj, value) => {
                                                            const objetivoId = filteredListObjectivesNoDuplicates[keyObj].objetivo_id.toString();
                                                            
                                                            return (
                                                                <ListItem
                                                                    id={objetivoId}
                                                                    key={objetivoId}
                                                                    className={objetivoId === this.state.activeObjetivoId ? classes.activeListItem : classes.listItem}
                                                                    activeClassName={classes.activeListItem}
                                                                    tabIndex={value}
                                                                    onClick={() => {
                                                                        this.props.history.push({pathname: `/online/${objetivoId}/${filteredListObjectivesNoDuplicates[keyObj].nombre}/${filteredListObjectivesNoDuplicates[keyObj].nombre_servicio_unificado}`,
                                                                        search: getQueryParams(),
                                                                        state: {
                                                                            fromObjective: filteredListObjectivesNoDuplicates[keyObj]
                                                                        }})
                                                                    }}
                                                                >
                                                                    <ListItemIcon className={classes.listItemIcon}>
                                                                        <TimelineIcon style={{color:filteredListObjectivesNoDuplicates[keyObj].color}} />
                                                                    </ListItemIcon>
                                                                    <ListItemText
                                                                        classes={{ primary: classes.listItemText }}
                                                                        primary={filteredListObjectivesNoDuplicates[keyObj].nombre}
                                                                        //Cambia estructura, para agregar estilo custom directo
                                                                        secondary={<div style={{ color: '#b2b2b2',  fontWeight: 'bold', }}>{filteredListObjectivesNoDuplicates[keyObj].nombre_servicio_unificado}</div>}
                                                                    />
                                                                </ListItem>
                                                            )
                                                        })
                                                    }
                                                </Paper>
                                            </List>
                                        </Popover>
                        :
                        <List
                            component="div"
                            disablePadding
                            subheader={
                                <Grid
                                    container
                                    className={classes.listItemIconFilter}
                                >

                                    <Grid
                                        item
                                        xs={7}
                                        sm={7}
                                        md={7}
                                        xl={7}
                                    >
                                        <Icon onClick={this.toggleReport} style={{ display:"inline-block", width:"35px"}}>
                                            {profileNoSpecial.includes(profileId)===false?
                                            special?
                                                <Tooltip title={t('sidebar.monitorings.tooltip')} placement="top-start">
                                                    <Typography style={{fontWeight: 'bold', color:"white", fontSize:"18px", paddingTop:"3px", cursor: 'pointer'}}>M</Typography>
                                                </Tooltip>
                                                :
                                                <Tooltip title={t('sidebar.monitorings_special.tooltip')} placement="top-start">
                                                    <Typography style={{fontWeight: 'bold', color:"white", fontSize:"18px", paddingTop:"3px", cursor: 'pointer'}}>R.E.</Typography>
                                                </Tooltip>
                                            :null

                                            }
                                        </Icon>

                                        <Tooltip title={t('sidebar.update')} placement="top-start">
                                            <UpdateIcon  variant="contained" onClick={this.handleClickUpdate} className={classes.ballotIcon} />
                                        </Tooltip>
                                        <Tooltip title={t('sidebar.summary_monitorings')} placement="top-start">
                                        <BarChartOutlinedIcon variant="contained" onClick={this.handleClickModal} className={classes.ballotIcon}/> 
                                        </Tooltip>
                                        <Tooltip title={t('sidebar.filter_service')} placement="top-start">
                                        {isBallotIconChecked ? 
                                            <FilterListIcon variant="contained" onClick={this.handleClick} className={classes.ballotIconChecked}/> :
                                            <FilterListIcon variant="contained" onClick={this.handleClick} className={classes.ballotIcon}/>
                                        }
                                        </Tooltip>
                                        <Tooltip title={t('sidebar.filter_tags')} placement="top-start">
                                            <LocalOfferIcon
                                                variant="contained"
                                                className={this.state.filterTags.length ? classes.ballotIconChecked : classes.ballotIcon}
                                                onClick={this.handleClickBtnFiltroEtiquetas}
                                            />
                                        </Tooltip>
                                        <div>
                                            <Modal
                                                aria-labelledby="simple-modal-title"
                                                aria-describedby="simple-modal-description"
                                                open={openModal}
                                                onClose={this.handleCloseModal}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                                disableAutoFocus={true}
                                                disableEnforceFocus={true}
                                                closeAfterTransition
                                                BackdropComponent={Backdrop}
                                                BackdropProps={{
                                                    timeout: 500,
                                                }}
                                            >
                                                <Fade in={openModal}>
                                                    <PerfectScrollbar>
                                                    <div className={classes.modal}>
                                                        <SummaryObjectives params={listaObjetivos} handleClose={this.handleCloseModal} isForModal={true}/>
                                                    </div>
                                                    </PerfectScrollbar>
                                                </Fade>
                                            </Modal>
                                        </div>

                                        <Popover open={open} onClose={this.handleClose}
                                                //anchorReference="anchorPosition"
                                                //anchorPosition={{ top: 170, left: 220 }}
                                                anchorEl={anchorEl}
                                                anchorOrigin={{vertical: 'top', horizontal: 'right',}}
                                                  transformOrigin={{vertical: 'center', horizontal: 'left',}}>
                                                <Paper style={{ minHeight: 50,
                                                    maxHeight: 400,
                                                    overflow: 'auto',
                                                    }}
                                                    className={classes.customScrollBar}
                                                >
                                                    <List   disablePadding>
                                                        {Object.keys(listaServicios).map(key => (
                                                                <ListItem
                                                                    component="div"
                                                                    key={key}
                                                                    role={undefined}
                                                                    dense button
                                                                    onClick={this.handleToggle(key)}
                                                                >
                                                                    <ListItemIcon className={classes.listItemIcon} >
                                                                        <Checkbox
                                                                            style ={{
                                                                                color: "#f57000",
                                                                            }}
                                                                            edge="start"
                                                                            checked={checked.indexOf(parseInt(key)) !== -1}
                                                                            tabIndex={-1}
                                                                            disableRipple
                                                                            inputProps={{ 'aria-labelledby': key }}
                                                                        />
                                                                    </ListItemIcon>
                                                                    <ListItemText id={key} primary={listaServicios[key]} />
                                                                </ListItem>
                                                        ))}
                                                    </List>
                                                </Paper>
                                        </Popover>
                                    </Grid>
                                </Grid>
                            }
                        >
                            <Paper style={{ minHeight: 50,
                                            maxHeight: 400,
                                            overflow: 'auto',
                                            overflowX: 'hidden',
                                            backgroundColor: '#0b1738',
                                        }}
                                    className={classes.customScrollBar}>
                                {cargando ?
                                    <div className={classes.profile}>
                                        <CircularProgress />
                                    </div>
                                    : 
                                    special?
                                    listObjectivesSpecials.map((keyObj) => (
                                        <ListItem
                                            key={keyObj.objetivo_id}
                                            className={classes.listItem}
                                            activeClassName={classes.activeListItem}
                                            component={NavLink}
                                            to={{
                                                pathname: `/especial/${keyObj.objetivo_id}/${keyObj.nombre}`,
                                                search: getQueryParams(),
                                                state: {
                                                    fromObjective: keyObj
                                                }
                                            }}
                                        >
                                            <ListItemIcon className={classes.listItemIcon}>
                                                <TimelineIcon style={{color:"#3eeacc"}} />
                                            </ListItemIcon>
                                            <ListItemText
                                                classes={{ primary: classes.listItemText }}
                                                primary={keyObj.nombre}
                                                //Cambia estructura, para agregar estilo custom directo
                                                secondary={<div style={{ color: '#b2b2b2',  fontWeight: 'bold', }}>{keyObj.nombre_servicio}</div>}
                                            />
                                        </ListItem>
                                        ))
                                    :
                                    Object.keys(filteredListObjectivesNoDuplicates).map((keyObj, value) =>
                                        {
                                        const objetivoId = filteredListObjectivesNoDuplicates[keyObj].objetivo_id.toString()

                                        return (
                                        <ListItem
                                            id={objetivoId}
                                            key={objetivoId}
                                            className={objetivoId === this.state.activeObjetivoId ? classes.activeListItem : classes.listItem}
                                            activeClassName={classes.activeListItem}
                                            tabIndex={value}
                                        >
                                            <ListItemText
                                                classes={{ primary: classes.listItemText }}
                                                primary={
                                                    <Link to={{
                                                        pathname: `/online/${objetivoId}/${filteredListObjectivesNoDuplicates[keyObj].nombre}/${filteredListObjectivesNoDuplicates[keyObj].nombre_servicio_unificado}`,
                                                        search: getQueryParams(),
                                                        state: {
                                                            fromObjective: filteredListObjectivesNoDuplicates[keyObj]
                                                        }
                                                    }}>
                                                        <div style={{display: "flex"}}>
                                                            <div style={{padding: 5, marginRight: 5, display: "flex", alignItems: "center"}}>
                                                                <TimelineIcon style={{color:filteredListObjectivesNoDuplicates[keyObj].color}} />
                                                            </div>
                                                            <div style={{color: "#b2b2b2"}}>
                                                                {filteredListObjectivesNoDuplicates[keyObj].nombre}
                                                                <div style={{ color: '#b2b2b2',  fontWeight: 'bold', fontSize: 12 }}>
                                                                    {filteredListObjectivesNoDuplicates[keyObj].nombre_servicio_unificado}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                }
                                                //Cambia estructura, para agregar estilo custom directo
                                                secondary={
                                                    <>
                                                        {
                                                            (filteredListObjectivesNoDuplicates[keyObj].Etiquetas && filteredListObjectivesNoDuplicates[keyObj].Etiquetas.length) ? 
                                                            <div style={{display: "flex", flexWrap: "wrap", marginTop: 2, width: "95%"}}>
                                                                {
                                                                filteredListObjectivesNoDuplicates[keyObj].Etiquetas.slice(0, 2).map(item => (
                                                                    <div style={{padding: 2}}>
                                                                        <ChipTag nombre={item.nombre} color={item.color} />
                                                                    </div>
                                                                ))
                                                                }
                                                                {filteredListObjectivesNoDuplicates[keyObj].Etiquetas.length > 2 ? 
                                                                    <ChipVerMas etiquetas={filteredListObjectivesNoDuplicates[keyObj].Etiquetas} length={2} />
                                                                : null}
                                                            </div>
                                                            : null
                                                        }
                                                    </>
                                                }
                                            />
                                        </ListItem>
                                        )
                                    })
                                }
                            </Paper>
                        </List>
                    }
                    </Collapse>
                </List>
                {/* Seccion Soporte y Herramientas */}
                <Divider className={classes.listDivider} />

                <ListItem
                        activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                        className={collapsed ? classes.listItemCollapsed : classes.listItem}
                        component={NavLink}
                        to={{
                            pathname: `/support`,
                            search: getQueryParams(),
                            state: {
                                Graph:1
                            }
                        }}
                    >
                        <ListItemIcon className={classes.listItemIcon}>
                            <Tooltip title={t('sidebar.support.tooltip')} placement="top-start">
                                <QuizIcon />
                            </Tooltip>
                        </ListItemIcon>
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary={t('sidebar.support')}
                        />
                    </ListItem>
                    <Divider className={classes.listDivider} />

                    <ListItem onClick={this.handleCollapseClick} 
                        activeClassName={collapsed ? classes.activeListItemCollapsed : classes.activeListItem}
                        className={collapsed ? classes.listItemCollapsed : classes.listItem}>
                    <ListItemIcon className={classes.listItemIcon}>
                        <Tooltip title={t('sidebar.support_tools.tooltip')} placement="top-start">
                            <SettingsOutlinedIcon />
                        </Tooltip>
                    </ListItemIcon>
                    {collapsed ? null :
                        <ListItemText
                            classes={{ primary: classes.listItemText }}
                            primary={t('sidebar.support_tools')}
                        />}
                    {openCollapse ? <ExpandLessIcon style={{color:'white'}} /> : <ExpandMoreIcon style={{color:'white'}} />}
                            
                </ListItem>
                <List
                    component="div"
                    disablePadding
                >
                    <Collapse in={openCollapse} timeout="auto" unmountOnExit>
                        {/* si el sidebar esta 'collapse', muestra el menu en un popover, sino se muestra normal  */}
                        {collapsed ? 
                            <Popover
                                PaperProps={{ style: { width: '271px',  backgroundColor: '#0b1738' },}}
                                open={openCollapse} onClose={this.handleCollapseClick}
                                anchorEl={anchorElSupport}
                                anchorOrigin={{vertical: 'top', horizontal: 'right',}}
                                transformOrigin={{vertical: 'top', horizontal: 'left',}}
                                >
                                {objectiveConfigIsEnabled &&
                                    <ListItem
                                        activeClassName={classes.activeListItem}
                                        className={classes.listItem}
                                        component={NavLink}
                                        style={{marginTop:'10px'}}
                                        to={{pathname: "/manageObjectives", search: getQueryParams()}}
                                    >
                                        <ListItemIcon className={classes.listItemIcon}>
                                            <SettingsOutlinedIcon />
                                        </ListItemIcon>
                                        <ListItemText
                                            classes={{ primary: classes.listItemText }}
                                            primary={t('sidebar.configure_objectives')}
                                        />
                                    </ListItem>
                                }
                                <ListItem
                                    activeClassName={classes.activeListItem}
                                    className={classes.listItem}
                                    component={NavLink}
                                    style={{marginTop:'10px'}}
                                    to={{pathname: "/settings", search: getQueryParams()}}
                                >
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <SettingsOutlinedIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: classes.listItemText }}
                                        primary={t('sidebar.administration')}
                                    />
                                    
                                </ListItem>
                                {syncAvailabilityIsEnabled ?
                                <ListItem
                                    activeClassName={classes.activeListItem}
                                    className={classes.listItem}
                                    component={NavLink}
                                    style={{marginTop:'10px'}}
                                    to={{pathname: "/availability-sync", search: getQueryParams()}}
                                >
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <SyncIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: classes.listItemText }}
                                        primary={t('sidebar.integration_availability')}
                                    />
                                </ListItem>
                                : null}
                                {profileId == 1 ?
                                <ListItem
                                    activeClassName={classes.activeListItem}
                                    className={classes.listItem}
                                    component={NavLink}
                                    title={t('sidebar.maintenance')}
                                    style={{marginTop:'10px', marginBottom:'10px'}}
                                    to={{pathname: '/maintenance', search: getQueryParams()}}
                                >
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <SettingsOutlinedIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: classes.listItemText }}
                                        primary={t('sidebar.maintenance')}
                                    />
                                    
                                </ListItem>
                                :null}
                            </Popover>

                        : <List>
                            {objectiveConfigIsEnabled &&
                                <ListItem
                                    activeClassName={classes.activeListItem}
                                    className={classes.listItem}
                                    component={NavLink}
                                    to={{pathname: "/manageObjectives", search: getQueryParams()}}
                                >
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <SettingsOutlinedIcon />
                                    </ListItemIcon>
                                        <ListItemText
                                            classes={{ primary: classes.listItemText }}
                                            primary={t('sidebar.configure_objectives')}
                                        />
                                </ListItem>
                            }
                            <ListItem
                                activeClassName={classes.activeListItem}
                                className={classes.listItem}
                                component={NavLink}
                                to={{pathname: "/settings", search: getQueryParams()}}
                            >
                                <ListItemIcon className={classes.listItemIcon}>
                                    <SettingsOutlinedIcon />
                                </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: classes.listItemText }}
                                        primary={t('sidebar.administration')}
                                    />
                                
                            </ListItem>
                            {syncAvailabilityIsEnabled ?
                            <ListItem
                                activeClassName={classes.activeListItem}
                                className={classes.listItem}
                                component={NavLink}
                                to={{pathname: "/availability-sync", search: getQueryParams()}}
                            >
                                <ListItemIcon className={classes.listItemIcon}>
                                    <SyncIcon />
                                </ListItemIcon>
                                    <ListItemText
                                        classes={{ primary: classes.listItemText }}
                                        primary={t('sidebar.integration_availability')}
                                    />
                            </ListItem>
                            : null}
                                {profileId == 1 ?
                                <ListItem
                                    activeClassName={classes.activeListItem}
                                    className={classes.listItem}
                                    component={NavLink}
                                    title={t('sidebar.maintenance')}
                                    to={{pathname: '/maintenance', search: getQueryParams()}}
                                >
                                    <ListItemIcon className={classes.listItemIcon}>
                                        <SettingsOutlinedIcon />
                                    </ListItemIcon>
                                        <ListItemText
                                            classes={{ primary: classes.listItemText }}
                                            primary={t('sidebar.maintenance')}
                                        />
                                    
                                </ListItem>
                            :null}
                            </List>
                        }
                        

                    </Collapse>
                </List>
                <Divider className={classes.listDivider} />
                <Popover open={Boolean(anchorElEtiquetas)} onClose={() => this.setState({anchorElEtiquetas: null})}
                    anchorEl={anchorElEtiquetas}
                    anchorOrigin={{vertical: 'top', horizontal: 'right',}}
                        transformOrigin={{vertical: 'center', horizontal: 'left',}}>
                    <Paper style={{
                            maxHeight: 400,
                            overflow: 'auto',
                            backgroundColor: '#333333',
                            width: 300,
                            maxWidth: 500,
                        }}
                        className={classes.customScrollBar}>
                            <div style={{width: "100%"}}>
                                <FilterTags
                                    etiquetas={this.state.filterTags}
                                    updateEtiquetas={(etiquetas, filterType = 'OR') => {this.updateEtiquetas(etiquetas, filterType)}}
                                    directToPopover={true}
                                    directAnchorEl={anchorElEtiquetas}
                                    preload={false}
                                    filterTagsType={this.state.filterTagsType}
                                    showFilterType={true}
                                />
                            </div>
                    </Paper>
                </Popover>
            </nav>
        );

    }
}

Sidebar.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

export default compose(
    withRouter,
    withStyles(styles),
    withTranslation()
)(Sidebar);